import { render, staticRenderFns } from "./Advertising.vue?vue&type=template&id=19df0359&"
import script from "./Advertising.vue?vue&type=script&lang=js&"
export * from "./Advertising.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports